import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  takeUntil,
  tap,
} from 'rxjs';
import { RepoBusiness, RepoContact, RepoPosition } from '../../models/repo-business/repo-business.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import { PositionOrgPopupComponent } from '../position-org-popup/position-org-popup.component';
import { PositionsPopupComponent } from '../positions/positions-popup.component';
import { RepoBusinessPopupComponent } from '../repo-business-popup/repo-business-popup.component';
import { RepoContactsPopupComponent } from '../repo-contacts/repo-contacts-popup.component';
import { AuthService } from '../../services/auth.service';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';

@Component({
  selector: 'app-repo-business',
  templateUrl: './repo-business.component.html',
  styleUrls: ['./repo-business.component.scss']
})
export class RepoBusinessComponent extends BaseUnsubscribeComponent implements OnInit {

  error$ = this.repoBusinessFacade.error$;
  positions$ = this.repoBusinessFacade.positions$;
  allContacts$ = this.repoBusinessFacade.allContacts$;
  repoBusinesses$ = this.repoBusinessFacade.repoBusinesses$;
  positions: RepoPosition[] = [];
  contacts: RepoContact[] = [];
  allContacts: RepoContact[] = [];
  repoBusinesses: RepoBusiness[] = [];
  isUSA = false;
  public searchTerm: string;
  private positionsUpdated = new BehaviorSubject<RepoPosition[]>(this.positions);
  private contactsUpdated = new BehaviorSubject<RepoContact[]>(this.contacts);

  private _activeTab: string = 'organizations'; // Default tab

  public set activeTab(tab: string) {
    this._activeTab = tab;
  }
  public get activeTab(): string {
    return this._activeTab;
  }    

  public get OrgTitle(): string {
    return this.isUSA ? 'Organizations' : 'Organisations';
  }

  constructor(private readonly modalService: NgbModal,
    private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private authService: AuthService,
    private readonly repoBusinessService: RepoBusinessService
  ) {
      super();
  }
  
  public AddRepoContact() {
    this.openRepoContactPopup({ repoContactId: 0 } as RepoContact);
  }
  public EditRepoContact(contact: RepoContact) {
    this.repoBusinessService.getContactById(contact.repoContactId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.openRepoContactPopup(response);
    });
  }

  public AddRepoPosition() {
    this.openRepoPositionPopup({ positionId:0 } as RepoPosition);
  }
  public EditRepoPosition(position: RepoPosition) {
    this.repoBusinessService.getPositionById(position.positionId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.openRepoPositionPopup(response);
    }, (err) => this.httpErrorHandlerService.ShowErrorMessage(err));
  }

  private openRepoPositionPopup(position: RepoPosition) {
    const modalRef = this.modalService.open(PositionsPopupComponent, {
      size: '40-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.position = position;
  }

  openRepoBusinessPopup(business: RepoBusiness): void {
    const modalRef = this.modalService.open(RepoBusinessPopupComponent, {
      size: '50-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.data = business;
    modalRef.componentInstance.isUSA = this.isUSA;
  }
  openPositionListPopup(): void {
    if (this.positions == null) {
      this.repoBusinessFacade.loadPositions();
    }
    const modalRef = this.modalService.open(PositionOrgPopupComponent, {
      size: '40-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.isViewMode = true;
    modalRef.componentInstance.positions$ = this.positionsUpdated.asObservable();
  }

  private openRepoContactPopup(contact: RepoContact) {
    const modalRef = this.modalService.open(RepoContactsPopupComponent, {
      size: '50-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.contact = contact;
    modalRef.componentInstance.isUSA = this.isUSA;
  }

  ngOnInit(): void {
    this.authService.IsMemberFromUSA().pipe(takeUntil(this.unsubscribe$)).subscribe((isUSA) => {
      this.isUSA = isUSA;
    });
    this.attachEvents();
    this.loadTab('organizations');
  }
  private attachEvents(): void {
    this.positions$.pipe(takeUntil(this.unsubscribe$)).subscribe((positions) => {
      this.positions = positions;
      this.positionsUpdated.next(this.positions);
    });
   
    this.allContacts$.pipe(takeUntil(this.unsubscribe$)).subscribe((contacts) => {
      this.allContacts = contacts; // Load all contacts of member
    });
    this.error$.pipe(takeUntil(this.unsubscribe$)).subscribe((err) => {
      if (err) {
        this.httpErrorHandlerService.ShowErrorMessage(err);
      }
    });

    this.repoBusinesses$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((business) => {
        this.repoBusinesses = business;
      });
  }

  public ngAfterViewInit(): void {
    

  }

  public loadTab(tab: string): void {
    this.activeTab = tab;
    if (tab === 'contacts') {
      if (this.allContacts == null) {
        this.repoBusinessFacade.loadContacts();
      }
    } else if (tab === 'organizations') {
      if (this.repoBusinesses == null) {
        this.repoBusinessFacade.loadRepoBusinesses();
      }

    } else if (tab === 'positions') {
      if (this.positions == null) {
        this.repoBusinessFacade.loadPositions();
      }
    }
  }

}
